import gql from 'graphql-tag'

export default gql`
  fragment FieldValueData on FieldValueNode {
      name
      ratio
  }
`